import React from 'react';
import GlobalStyle from './global/styles'
import RoutesComponent from './routes';
import { BrowserRouter } from 'react-router-dom';
import 'antd/dist/antd.css';
import { AuthProvider } from './hooks/auth';
import { ThemeProvider } from './hooks/useTheme';
function App() {
  return (
    <BrowserRouter>
    <AuthProvider>
    <ThemeProvider>
    <div className="App">
     <GlobalStyle />
    <RoutesComponent />
    </div>
      </ThemeProvider>
    </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
